import clsx from 'clsx';
import { ChevronDown } from 'react-bootstrap-icons';

import '@repo/sds/components/SDSChevronIcon/SDSChevronIcon.scss';

export interface SDSChevronIconProps {
  /**
   * Whether the chevron is in expanded state (rotated 180 degrees)
   */
  isExpanded?: boolean;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Color variant
   */
  color?: 'primary' | 'secondary' | 'inactive';
}

export function SDSChevronIcon({ isExpanded = false, size = 16, className, color = 'inactive' }: SDSChevronIconProps) {
  return (
    <span
      className={clsx(
        'SDSChevronIcon',
        `SDSChevronIcon--${color}`,
        {
          'SDSChevronIcon--expanded': isExpanded,
        },
        className,
      )}
      aria-hidden="true"
    >
      <ChevronDown size={size} />
    </span>
  );
}
